export default "__VITE_ASSET__p9SEXXzf__"